import { PollCRDT, emptyPoll, merge } from "./poll"
import { useModel } from "./lib/useModel"
import { Bus } from "@taliesinsoftworks/crdtbus"
import { repository } from "./lib/repository"
import { getOrCreateAgentId } from "./lib/getOrCreateAgentId"
import { useState } from "preact/hooks"

export function PollProvider(props: {
  key: string
  pollID: string
  children: (poll: Bus<PollCRDT>, agentID: string, setProfileID: (id: string) => void) => JSX.Element
}): JSX.Element {
  const myAgentId = getOrCreateAgentId()
  const [profileID, setProfileID] = useState(myAgentId)
  
  const bus = useModel(() =>
    Bus<PollCRDT>({
      topic: props.pollID,
      agentId: myAgentId,
      merge,
      ...repository<PollCRDT>(props.pollID, localStorage, emptyPoll),
      signalingServerHost: "drpeer.onrender.com",
    }),
  )

  return props.children(bus, profileID, setProfileID)
}
